import React, { useState, useEffect } from "react";
import "./css/botChats.css";
import "./css/three-dots.css";
import ReactSpeedometer from "react-d3-speedometer";

function BotChats({ botOutput, isWaiting }) {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [randomStyle, setRandomStyle] = useState("");

  useEffect(() => {
    const styles = ["dot-elastic", "dot-flashing", "dot-typing", "dot-pulse"];
    setRandomStyle(styles[Math.floor(Math.random() * styles.length)]);
  }, []);

  useEffect(() => {
    if (
      !isWaiting &&
      botOutput?.summry &&
      currentIndex < botOutput.summry.length
    ) {
      const timer = setTimeout(() => {
        setDisplayedText(botOutput.summry.slice(0, currentIndex + 1));
        setCurrentIndex((prev) => prev + 1);
      }, 5); // Faster for better readability
      return () => clearTimeout(timer);
    }
  }, [currentIndex, botOutput, isWaiting]);

  const isComplete =
    !isWaiting && botOutput?.summry && currentIndex >= botOutput.summry.length;

  // Helper to parse line content for bold text
  const renderLineContent = (text) => {
    return text
      .split(/(\*\*.*?\*\*)/g)
      .map((part, j) =>
        part.startsWith("**") ? (
          <strong key={j}>{part.replace(/\*\*/g, "")}</strong>
        ) : (
          part
        ),
      );
  };

  return (
    <div className={`bot-chat-wrapper ${isComplete ? "typing-done" : ""}`}>
      <div className="bot-header">
        <div className="bot-identity">
          <img src="./Assets/robot.png" alt="Bot" className="bot-avatar-mini" />
          <span className="bot-name-tag">Opinion Bot</span>
        </div>
      </div>

      <div className="bot-body">
        {isWaiting ? (
          <div className="loader-container">
            <div className={randomStyle}></div>
            <span>Analyzing sentiments...</span>
          </div>
        ) : (
          <div className="response-container">
            <div className="rich-text">
              {displayedText.split("\n").map((line, i) => {
                if (
                  line.trim().startsWith("*") ||
                  line.trim().startsWith("-")
                ) {
                  return (
                    <li key={i} className="list-item">
                      {renderLineContent(line.replace(/^[* -]+/, ""))}
                    </li>
                  );
                }
                return (
                  <p key={i} className="text-para">
                    {renderLineContent(line)}
                  </p>
                );
              })}
            </div>

            {isComplete && (
              <div className="analysis-viz">
                <div className="viz-header">
                  <h4>Sentiment Distribution</h4>
                </div>
                <div className="meter-wrapper">
                  <ReactSpeedometer
                    width={280}
                    height={180}
                    needleHeightRatio={0.7}
                    value={Number(botOutput.positive_comments)}
                    maxValue={
                      Number(botOutput.negetive_comments) +
                      Number(botOutput.positive_comments)
                    }
                    currentValueText="Happiness Index"
                    needleColor="#ff9130"
                    startColor="#ff4b2b"
                    endColor="#00f2fe"
                    segments={5}
                    textColor="#888"
                    labelFontSize="10px"
                    ringWidth={40}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BotChats;
